"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicLinkStyle = void 0;
const react_1 = require("@emotion/react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const dynamicLinkStyle = (color, hoverColor, disabled, active) => react_1.css `
    color: ${disabled ? styles_scss_1.default.silver : color};
    color: ${active ? `${styles_scss_1.default.primary} !important` : ''} ;
    &:hover {
      color: ${disabled ? styles_scss_1.default.silver : hoverColor};
    };
    font-weight: ${active ? '500 !important' : ''};
    font-size: ${styles_scss_1.default.s};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    pointer-events: ${disabled ? 'none' : 'auto'};
  `;
exports.dynamicLinkStyle = dynamicLinkStyle;
